import React, { useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { MorphologyStore } from './MorphologyStore';
import { useAmplitudeTracking, useFirstTimeInstructions, useIsMobileDimensions, useKeyboardInput, usePageVisibilityPause, useStructuredDataEmbedding } from '../shared/utils';
import { checkPuzzle, handleInput, saveMorphology } from './morphologyUtils';
import { PuzzleNames } from '../../../utils/types';
import DesktopMorphology from './components/DesktopMorphology';
import MobileMorphology from './components/MobileMorphology';
import { usePuzzleTracking } from '../../../utils/usePuzzleTracking';
import '../shared/puzzles.less';
import './Morphology.less';

const Morphology = () => {
  const { autocheckOn, guesses, completed } = MorphologyStore.useState();

  // It's intended to take `revealed` & `solved`, but morphology only uses `completed`,
  // so I'm just passing that for both those params so I don't have to make a separate hook.
  useKeyboardInput(handleInput, completed, completed);
  usePageVisibilityPause(MorphologyStore as any, saveMorphology);
  useFirstTimeInstructions(PuzzleNames.Morphology, MorphologyStore as any);
  useStructuredDataEmbedding(PuzzleNames.Morphology);
  useAmplitudeTracking(PuzzleNames.Morphology);
  usePuzzleTracking(PuzzleNames.Morphology);

  useEffect(() => {
    if (autocheckOn) checkPuzzle();
  }, [guesses, autocheckOn]);

  const useMobileStyles = isMobile || useIsMobileDimensions();

  return (
    <div className={`puzzleContainer ${useMobileStyles ? 'mobile' : ''}`}>
      {useMobileStyles && <MobileMorphology/>}
      {!useMobileStyles && <DesktopMorphology/>}
    </div>
  );
};

export default Morphology;